// export const BASE_URL = "http://209.105.243.210:8800/api/v1/";
// export const SITE_URL = "http://209.105.243.210:8800/";
export const BASE_URL = "https://reports.khuddam.ng/service/api/v1/";
export const SITE_URL = "https://reports.khuddam.ng/service/";
